import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "../../../services/common.service";
import { AuthService } from "../../../services/auth.service";
import { ReservationService } from "../../../services/reservation.service";

@Component({
  selector: "page-auth-index",
  templateUrl: "./index.component.html",
})
export class PageAuthIndexComponent implements OnInit {
  /* ALLOWED SOCIALS */
  public allowedSocial = [
    "facebook",
    "line",
    "google",
    "yahoo",
    "instagram",
    "twitter",
  ];
  public social: any;
  public returnData: any;

  constructor(
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public authService: AuthService,
    public reservationService: ReservationService
  ) {}

  async ngOnInit() {
    /* SET PAGE TITLE */
    this.commonService.setTitle(`ログインする`);

    let token = this.commonService.getHash("access_token");
    this.social = this.activatedRoute.snapshot.paramMap.get("social");

    if (
      this.social &&
      this.allowedSocial.indexOf((this.social = this.social.toLowerCase())) !==
        -1
    ) {
      /*
       * [F-8] OAuth state CSRF検証
       *
       * 【重要: フロントエンド・バックエンド同時デプロイ必須】
       * この検証はバックエンド AuthController.php の修正とセットです。
       * バックエンドが oauth_state を返さない旧バージョンのままだと、
       * ここでの検証が必ず失敗してログインできなくなります。
       * 必ず両方同時にデプロイしてください。
       *
       * Facebook: バックエンドがリダイレクトURLのクエリパラメータ ?oauth_state=xxx で返す
       * LINE: バックエンドがJSONレスポンスの oauth_state フィールドで返す（loginWithLineAccessToken内で検証）
       */
      if (this.social === 'facebook') {
        const returnedState = this.activatedRoute.snapshot.queryParams['oauth_state'] || '';
        if (!this.authService.verifyOAuthState('facebook', returnedState)) {
          this.commonService.hidePageLoader();
          this.returnData = { status: "fail", message: "セキュリティ検証に失敗しました。再度ログインしてください。" };
          return;
        }
      }

      /* LANGUAGE INIT */
      /* await this.langService.init(); */
      this.commonService.showPageLoader("ログイン中・・・");
      /* END */

      let returnData: any;
      let currentAccount = this.authService.getUserData();

      switch (this.social) {
        case "facebook":
          returnData = await this.authService.loginWithFacebookToken(token);
          break;

        case "line":
          returnData = await this.authService.loginWithLineAccessToken(token);
          break;

        case "google":
          returnData = await this.authService.loginWithGoogleAccessToken(token);
          break;

        case "yahoo":
          returnData = await this.authService.loginWithYahooAccessToken(token);
          break;

        case "instagram":
          returnData = await this.authService.loginWithInstagramAccessToken(
            token
          );
          break;

        case "twitter":
          let oauthToken = this.activatedRoute.snapshot.queryParams.oauth_token;
          let oauthVerifier =
            this.activatedRoute.snapshot.queryParams.oauth_verifier;
          /* TO DO */

          returnData = await this.authService.loginWithTwitterAccessToken({
            oauthToken: oauthToken,
            oauthVerifier: oauthVerifier,
          });
          break;
      }

      /* HIDE PAGE LOADER */
      this.commonService.hidePageLoader();

      if (returnData.status == "success") {
        if (
          this.authService.isLoggedIn() &&
          currentAccount &&
          returnData.data.userData.id != currentAccount.userData.id
        ) {
          /* LOGGING TO OLD ACCOUNT FOR SWITCHING */
          this.authService.login(currentAccount);

          this.returnData = { status: "switchAccount", data: returnData.data };
        } else {
          this.doRedirect();
        }
      } else {
        this.returnData = { status: "fail", message: returnData.message };
      }
    } else {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageHome
      );
    }
  }

  switchAccount() {
    this.authService.login(this.returnData.data);
    this.doRedirect(false);
  }

  async doRedirect(checkLinking: boolean = true) {
    let returnURL = this.commonService.getCurrentURL();

    if (checkLinking) {
      if (
        returnURL.indexOf(
          this.commonService.routePaths.pageProfileIndexNoParam
        ) !== -1
      ) {
        this.commonService.setData("socialAccountLinkedStatus", {
          status: "success",
          message: `[${String(
            this.social
          ).toUpperCase()}] ソーシャルアカウントが正常にリンクされました`,
        });
      } else if (
        returnURL.indexOf(
          this.commonService.routePaths.pageReserveIndexNoParam
        ) !== -1
      ) {
        /* RESERVATION FLOW */
        /* SHOW LOADER */
        this.commonService.showPageLoader("読み込み中...");

        await this.reservationService.createReservationData(
          this.commonService.appConfig.reservation.registerWithBookingOff
        );

        /* HIDE LOADER */
        this.commonService.hidePageLoader();
      }
    }

    window.location.href = returnURL;
  }
}
